<template>
  <div>
    <div class="bg-light-gray rounded-bottom p-2">
      <div class="bg-white rounded py-4" :class="isMobile ? 'px-3' : 'px-4'">
        <p class="font-16 mb-3">
          <i class="fas fa-share-square font-20 mr-2 text-orange"></i>
          Compartir informe
        </p>

        <div
          class="row rounded"
          :class="[!isMobile && 'share-wrapper', users.length && 'bg-gray']"
        >
          <div
            class="col-12 col-md-6 py-3"
            :class="[users.length ? 'rounded-left' : 'rounded bg-gray']"
          >
            <validation-observer ref="form">
              <div class="d-flex align-items-start flex-column h-100 max-h">
                <div class="mb-auto w-100">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="`required|email`"
                    name="emailSelection"
                    mode="eager"
                    :custom-messages="{
                      required: 'El correo electrónico es requerido.',
                      email: 'El correo electrónico no es válido.',
                      mustBeEmailSelection:
                        'El correo electrónico no es válido.',
                    }"
                  >
                    <div class="flex pl-2 search-bar bg-gray">
                      <custom-auto-complete
                        class="search-bar__search-input"
                        id="input-email"
                        label="Seleccione un usuario:"
                        ref="autocompleteUserRef"
                        placeholder="Búsqueda de Usuario"
                        v-model="searchEmailSnapshot.input"
                        v-on="$listeners"
                        :debounce-time="500"
                        :get-result-value="getResultValue"
                        :search="searchHandler"
                        :error="errors[0]"
                        @submit="handleSubmit"
                        :class="isMobile && 'mb-2'"
                      />
                      <div class="search-bar__share-btn">
                        <action-button
                          i="fas fa-share-square"
                          variant="success"
                          id="btn-search"
                          text="Compartir"
                          class="float-left"
                          @click="handlerShare"
                        />
                      </div>
                    </div>
                  </validation-provider>
                  <div>
                    <custom-chips-group
                      v-if="model.users.length"
                      class="text-left"
                      no-background
                      no-wrap
                      object-title="fullName"
                      object-text="roleName"
                      @itemMarkedForDeletion="onItemDeletedHandler"
                      :selected-items="model.users"
                      title=""
                    />
                  </div>
                </div>
                <div v-if="isMobile" class="row mt-4 mb-3 w-100">
                  <div
                    class="col-12 d-flex mr-md-5 justify-content-center w-100 px-0"
                  >
                    <div class="row w-100">
                      <div class="col-12 mb-2 px-0 ml-2">
                        <action-button
                          i="fas fa-share-square"
                          variant="success"
                          id="btn-search"
                          text="Compartir"
                          class="ml-2 mb-2 w-100"
                          @click="handlerShare"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
          <div
            v-if="users.length"
            class="col-12 col-md-6 pt-3 pb-4 rounded-right pr-md-0"
            :class="
              isMobile
                ? 'users-wrapper px-5'
                : 'bg-gray overflow-auto h-100 scroll-hide max-h'
            "
          >
            <p class="font-16 mb-0">
              <i class="fas fa-user-friends font-20 mr-2 text-orange"></i>
              Usuarios con acceso:
            </p>
            <div class="row justify-content-between mt-2 px-0 px-md-3">
              <div
                v-for="user in users"
                :key="user.userId"
                class="col-12 col-md-6 d-flex justify-content-between bg-white border rounded pt-2 mb-3 user"
              >
                <div class="d-flex flex-column">
                  <p class="font-16 m-0">{{ user.fullName }}</p>
                  <p class="font-14 text-muted">{{ user.roleName }}</p>
                </div>
                <div class="d-flex align-items-center mb-2">
                  <i
                    class="fas fa-times font-20 mr-2 user-remove-icon cursor-pointer"
                    @click="handlerRemoveUser(user)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5" :class="isMobile && 'w-100'">
          <div
            class="col-12 d-flex justify-content-center justify-content-md-end"
            :class="isMobile && 'w-100 px-0 ml-2'"
          >
            <action-button
              @click="$emit('close')"
              i="fas fa-times-circle"
              variant="outline-danger"
              id="btn-search"
              text="Cerrar"
              class="mr-3"
              :class="isMobile && 'w-100 ml-3'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomAutoComplete, CustomChipsGroup } from '@/components/common'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ActionButton from 'ActionButton'
import SpecialService from '@/services/api/special.api'
import { searchUserEmail } from '@/core/auth'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

export default {
  name: 'ShareInform',
  components: {
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    CustomAutoComplete,
    CustomChipsGroup,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    informId: {
      type: Number,
      default: () => null,
    },
  },
  data: () => ({
    users: [],
    model: {
      users: [],
    },
    searchEmailSnapshot: {
      input: '',
      data: [],
    },
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    usersOptions() {
      return (
        this.searchEmailSnapshot.data.filter(
          (el) => !this.users.find((rm) => rm.id === el.id)
        ) || []
      )
    },
  },
  watch: {
    users: {
      handler(val) {
        if (val.length === 0) this.$emit('updateShareData', false)
        else this.$emit('updateShareData', true)
      },
      immediate: true,
    },
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      const { data } = await SpecialService.getSharedUser(this.informId)
      this.users = data
    },
    getResultValue(result) {
      return result.fullName
    },
    handleSubmit(val) {
      const exist = this.model.users.some((e) => e.userId === val.userId)
      if (!exist) this.model.users.push({ ...val })
      this.searchEmailSnapshot.input = null
      this.$refs.autocompleteUserRef.onClearHandler()
    },
    onItemDeletedHandler(item) {
      const user = this.model.users.find((e) => e.userId === item.userId)
      this.model.users.splice(this.model.users.indexOf(user), 1)
    },
    async handlerShare() {
      if (this.model.users.length === 0) {
        this.ShowToast(
          'Alerta',
          'Debe añadir al menos un usuario para poder compartir el informe',
          'error'
        )
        return
      }

      const payload = {
        users: [
          ...this.model.users.map((e) => ({ userId: e.userId, new: true })),
          ...this.users.map((e) => ({ userId: e.userId, new: false })),
        ],
        queryBuilderId: this.informId,
      }

      const { data } = await SpecialService.share(payload)

      if (data) {
        this.ShowToast(
          'Proceso exitoso',
          'Informe compartido exitosamente.',
          'success'
        )
        this.model.users = []
        this.getUsers()
      }
    },
    async handlerRemoveUser(user) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover los accesos a este reporte al usuario ${user.fullName}?`,
        'Sí',
        'No'
      )

      if (!answer) return

      const { data } = await SpecialService.removeSharedUser(
        this.informId,
        user.userId
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })

      if (data) {
        this.ShowToast(
          'Proceso exitoso',
          'El retiro de acceso al usuario ha sido realizado exitosamente.',
          'success'
        )
        this.model.users = []
        this.getUsers()
      }
    },
    searchHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([])
        }
        if (input == this.searchEmailSnapshot.input) {
          return resolve(
            this.searchEmailSnapshot.data.filter(
              (el) => !this.users.find((rm) => rm.userId === el.userId)
            )
          )
        }
        this.searchEmailSnapshot.input = input
        searchUserEmail({ name: input }).then(({ data: response }) => {
          this.searchEmailSnapshot.data = response.data.filter(
            (el) => !this.users.find((rm) => rm.userId === el.userId)
          )
          resolve(this.searchEmailSnapshot.data)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  width: 100%;

  @media (max-width: 992px) {
    flex-direction: column;
  }

  &__search-input {
    width: 100%;
    margin-right: 15px;

    @media (max-width: 992px) {
      margin-right: 0px;
    }
  }

  &__share-btn {
    display: flex;
    justify-content: flex-end;
    align-items: end;

    @media (max-width: 992px) {
      width: 100%;
      margin-top: 5px;
      button {
        width: 100%;
      }
    }
  }
}

.max-h {
  max-height: 370px;
}
.scroll-hide {
  overflow-x: hidden !important;
}
.max-height-100 {
  max-height: 232px !important;
  min-height: 232px !important;
}

.user-remove-icon {
  color: #e2e2e2;
}

.user {
  height: fit-content;
  word-break: break-all;
}

.share-wrapper {
  max-height: 370px;
}

.users-wrapper {
  overflow-y: scroll;
  height: 340px;
}

@media (min-width: 768px) {
  .col-md-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 49% !important;
  }
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  border-radius: 4px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
  border-radius: 10px;
  height: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e2e2e2;
  border-radius: 4px;
  height: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e2e2e2;
  border-radius: 4px;
  height: 5px;
}

::-webkit-scrollbar-button {
  height: 5px !important;
}
</style>
